import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { DistanceService } from '../proxy/general/controllers';

FieldBuilder.setNamespace('General');

export const DISTANCERANGE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.DistanceRange.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .foreignKey('startDistanceId', 'Entity.DistanceRange.StartDistance', DistanceService)
    .required()
    .display('distanceValue')
    .displayFromNested('startDistance.distanceValue')
    .sortBy('startDistance.distanceValue')
    .filterBy('startDistanceValue')
    .customFilter('number')
    .build(),
  FieldBuilder
    .foreignKey('endDistanceId', 'Entity.DistanceRange.EndDistance', DistanceService)
    .required()
    .display('distanceValue')
    .displayFromNested('endDistance.distanceValue')
    .sortBy('endDistance.distanceValue')
    .filterBy('endDistanceValue')
    .customFilter('number')
    .build(),
];

export const DISTANCERANGE_CONFIG = {
  entityName: 'DistanceRange',
  localizationKey: 'General::Entity.DistanceRange',
  fields: DISTANCERANGE_FIELDS,
  permission: 'ControllingLiquidations.DistanceRanges',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};